// Packages
import { isEmpty } from "lodash";

// Const
import {
  portTypeOptions,
} from '../../const';

export const getPortTypeOptionsLabel = (value) => {
  const option = portTypeOptions.find((opt) => opt.value === value);
  return option ? option.label : "-";
};

export const getSendRequestParams = ({
  auth,
  inFix = "",
  method = "read"
}) => {
  const isStandaloneMode = !auth.orgs || Object.keys(auth.orgs).length === 0;
  const apiBaseUrl = isStandaloneMode ? `/orgs/:orgId` : `/ents/:entId/orgs/:orgId`;
  const apiUrl = `${apiBaseUrl}/sites/:siteId/settings/${inFix}.${method}`;

  const requestParamsConfig = {
    standalone: {
      orgId: auth.realm?.id,
      siteId: auth.sites?.id,
    },
    nonStandalone: {
      entId: auth.realm?.id,
      orgId: auth.orgs?.id,
      siteId: auth.sites?.id,
    },
  };

  const requestParams = isStandaloneMode ? requestParamsConfig["standalone"] : requestParamsConfig["nonStandalone"];

  return {
    apiUrl,
    requestParams
  };
}

export const getCleanUpdatePayload = ({
  ports
}) => {

  if (isEmpty(ports)) return {}

  const waitingEditPorts = ports
    .filter(port => port.isWaitingEdit)
    .map(port => {
      let cleanAccessPolicy = null;
      if (port.accessPolicy) {
        if (port.accessPolicy.enableState) {
          cleanAccessPolicy = {
            enableState: true,
            type: port.accessPolicy.type,
            macList: (port.accessPolicy.type === "STATIC" || port.accessPolicy.type === "DELETE_ON_TIME")
              ? port.accessPolicy.macList
              : null,
            radiusProfile: port.accessPolicy.type === "8021X_PROFILE"
              ? port.accessPolicy.radiusProfile
              : null,
            dynamicSize: port.accessPolicy.type === "DELETE_ON_TIME"
              ? port.accessPolicy.dynamicSize
              : null,
          };
        } else {
          cleanAccessPolicy = {
            enableState: false,
            type: "STATIC",
            macList: null,
            radiusProfile: null,
            dynamicSize: null
          };
        }
      }

      return {
        id: port.id,
        portIndex: port.portIndex,
        portProfile: port.portProfile,
        PVID: port.PVID,
        allowVlan: port.allowVlan,
        ddpState: port.ddpState,
        deviceCategory: port.deviceCategory || "switch",
        lbdState: port.lbdState,
        poeState: port.isPoeScheduleMode ? true : port.poeState,
        portState: port.isPortScheduleMode ? true : port.portState,
        portSchedule: port.isPortScheduleMode ? port.portSchedule : null,
        poeSchedule: port.isPoeScheduleMode ? port.poeSchedule : null,
        portType: port.portType,
        speed: port.speed,
        rstpState: port.rstpState,
        stpState: port.stpState,
        operation: port.operation ? {
          type: port.operation.type || "switching",
          mirrorPort: port.operation.type === "mirroring" ? (port.operation.mirrorPort || []).map(Number) : [],
          mirrorMode: port.operation.type === "mirroring" ? (port.operation.mirrorMode || "") : "",
          aggregatePort: port.operation.type === "aggregation"
            ? (port.operation.aggregatePort || []).map(Number).filter(idx => idx !== port.portIndex)
            : [],
          aggregateType: port.operation.type === "aggregation" ? (port.operation.aggregateType || "").toLowerCase() : "",
          aggregateGroupId: port.operation.type === "aggregation"
            ? (port.operation.aggregateGroupId != null ? Number(port.operation.aggregateGroupId) : null)
            : null
        } : {
          type: "switching",
          mirrorPort: [],
          mirrorMode: "",
          aggregatePort: [],
          aggregateType: "",
          aggregateGroupId: null
        },
        accessPolicy: cleanAccessPolicy
      };
    });

  const macAddress = ports.find(port => port.macAddress)?.macAddress ?? "";

  const cleanPayload = [{
    "deviceId": macAddress,
    "wired.port": waitingEditPorts
  }]

  return cleanPayload;
}

// Returns null if no group id is available.
export const getAvailableAggregateGroupId = (switchesData, macAddress, currentGroupId, maxGroups) => {
  if (currentGroupId != null && currentGroupId !== "" && !isNaN(Number(currentGroupId)) && Number(currentGroupId) > 0) {
    return Number(currentGroupId);
  }

  const devicePorts = (switchesData || []).filter(p => p.macAddress === macAddress);

  const usedGroupIds = new Set(
    devicePorts
      .filter(p => p.operation?.type === "aggregation" && p.operation?.aggregateGroupId != null)
      .map(p => Number(p.operation.aggregateGroupId))
  );

  const candidates = [];
  for (let i = 1; i <= (maxGroups || 0); i++) {
    if (!usedGroupIds.has(i)) {
      candidates.push(i);
    }
  }

  if (candidates.length === 0) return null;

  const randomIndex = Math.floor(Math.random() * candidates.length);
  return candidates[randomIndex];
};

export const isPortInOtherAggregateGroup = ({
  portItem,
  selectedIndexList,
  switchesData,
  macAddress
}) => {
  if (selectedIndexList.includes(portItem.portIndex)) return false;
  const devicePorts = (switchesData || []).filter((swPort) => swPort.macAddress === macAddress);
  return devicePorts.some((swPort) => {
    if (selectedIndexList.includes(swPort.portIndex)) return false;
    const op = swPort.operation;
    if (op?.type !== "aggregation") return false;
    const aggPorts = (op?.aggregatePort || []).map(Number);

    // 若該 aggregation group 中包含任何當前正在編輯的 port, 代表屬於同一個群組的.
    const isSameGroup = aggPorts.some(port => selectedIndexList.includes(port)) || selectedIndexList.includes(Number(swPort.portIndex));
    if (isSameGroup) {
      return false;
    }

    return swPort.portIndex === portItem.portIndex || aggPorts.includes(portItem.portIndex);
  });
};